// extracted by mini-css-extract-plugin
export default {"container":"xaa-z","oos":"yaa-z","oosUx":"zaa-z","selected":"Aaa-z","labelOos":"Baa-z"};